/*
 * @Author: yzr
 * @Date: 2020-11-24 09:37:03
 * @LastEditors: yzr
 * @LastEditTime: 2020-11-24 10:01:11
 */
import Ads from './index.vue';

export default Ads;
